import SidebarLayout from './container';

export default SidebarLayout;
